<template>
  <div class="login_container">
    <img id="image" style="width: 1px; height: 1px" :src="imageurl" alt="Picture" />
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      imageurl: ''
    }
  },
  mounted () {
    // 获取参数
    this.imageurl = localStorage.getItem('imagereviewurl')
    setTimeout(function () {
      const viewer = new Viewer(document.getElementById('image'), {
        inline: true,
        viewed () {
          viewer.zoomTo(1)
        },
        toolbar: {
          zoomIn: 4,
          zoomOut: 4,
          oneToOne: 4,
          reset: 4,
          prev: 0,
          play: {
            show: 0,
            size: 'large'
          },
          next: 0,
          rotateLeft: 4,
          rotateRight: 4,
          flipHorizontal: 4,
          flipVertical: 4
        }
      })
    }, 500)
  },
  methods: {
    erpLogin: function (loginname, password) {
      var that = this
      var data = {
        os: 'erp',
        loginname: loginname,
        password: password,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      axios.post(Vue.prototype.global.Url_ErpLogin, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            // 保存数据
            localStorage.setItem('Useriderp', response.data.Useriderp)
            localStorage.setItem('Nicename', response.data.Nicename)
            localStorage.setItem('Authtokenerp', response.data.Authtokenerp)
            // 跳转
            that.$router.push('/Home')
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }

}
</script>

<style lang="less" scoped>
.login_container {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
